import React from 'react';

const ecdConnectRobot = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="112"
    height="143"
    viewBox="0 0 112 143"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4979_1279)">
      <path
        d="M47.6166 110.581H39.7812V135.17H47.6166V110.581Z"
        fill="#83BB26"
      />
      <path
        d="M49.0843 121.25H38.3164V124.638H49.0843V121.25Z"
        fill="#1DBADF"
      />
      <path
        d="M49.0843 131.461H38.3164V134.849H49.0843V131.461Z"
        fill="#1DBADF"
      />
      <path
        d="M71.6283 111.085H63.793V135.216H71.6283V111.085Z"
        fill="#83BB26"
      />
      <path
        d="M73.0921 121.25H62.3242V124.638H73.0921V121.25Z"
        fill="#1DBADF"
      />
      <path
        d="M73.0921 131.461H62.3242V134.849H73.0921V131.461Z"
        fill="#1DBADF"
      />
      <path
        d="M74.3755 138.329C74.7879 139.108 74.4671 139.749 73.5965 139.749H63.0119C62.1413 139.749 61.8206 139.108 62.233 138.329L63.3327 136.36C63.7451 135.582 64.7989 134.941 65.6695 134.941H71.0306C71.9012 134.941 72.9092 135.582 73.3674 136.36L74.3755 138.329Z"
        fill="#83BB26"
      />
      <path
        d="M57.9739 141.443C57.699 142.313 58.2031 143 59.0278 143H77.5395C78.4101 143 78.8683 142.313 78.5934 141.443L78.2268 140.299C77.9519 139.429 77.0354 138.742 76.2107 138.742H60.3566C59.486 138.742 58.5696 139.429 58.3405 140.299L57.9739 141.443Z"
        fill="#FF2180"
      />
      <path
        d="M49.4955 138.329C49.9079 139.108 49.5872 139.749 48.7166 139.749H38.0861C37.2156 139.749 36.8948 139.108 37.3072 138.329L38.4069 136.36C38.8193 135.582 39.8732 134.941 40.7438 134.941H46.059C46.9296 134.941 47.9376 135.582 48.3958 136.36L49.4955 138.329Z"
        fill="#83BB26"
      />
      <path
        d="M33.0911 141.443C32.8162 142.313 33.3202 143 34.145 143H52.6567C53.5273 143 53.9855 142.313 53.7105 141.443L53.344 140.299C53.069 139.429 52.1526 138.742 51.3278 138.742H35.4738C34.6032 138.742 33.6868 139.429 33.4577 140.299L33.0911 141.443Z"
        fill="#FF2180"
      />
      <path
        d="M73.9185 112.001C74.3309 111.222 74.0101 110.581 73.1395 110.581H62.5549C61.6843 110.581 61.3636 111.222 61.7759 112.001L62.8756 113.969C63.288 114.748 64.3419 115.389 65.2125 115.389H70.5736C71.4441 115.389 72.4522 114.748 72.9104 113.969L73.9185 112.001Z"
        fill="#83BB26"
      />
      <path
        d="M50.0463 112.001C50.4587 111.222 50.138 110.581 49.2674 110.581H38.6369C37.7663 110.581 37.4456 111.222 37.858 112.001L38.9577 113.969C39.3701 114.748 40.4239 115.389 41.2945 115.389H46.6556C47.5262 115.389 48.5342 114.748 48.9924 113.969L50.0463 112.001Z"
        fill="#83BB26"
      />
      <path
        d="M66.4485 58.931C66.4485 60.9 61.958 62.4568 56.4137 62.4568C50.8694 62.4568 46.3789 60.8542 46.3789 58.931C46.3789 57.0079 50.8694 55.4053 56.4137 55.4053C61.958 55.4053 66.4485 56.9621 66.4485 58.931Z"
        fill="#83BB26"
      />
      <path
        d="M66.4485 63.2806C66.4485 65.2496 61.958 66.8064 56.4137 66.8064C50.8694 66.8064 46.3789 65.2038 46.3789 63.2806C46.3789 61.3575 50.8694 59.7549 56.4137 59.7549C61.958 59.7091 66.4485 61.3117 66.4485 63.2806Z"
        fill="#83BB26"
      />
      <path
        d="M81.6175 108.383C81.8008 109.62 80.7011 110.856 79.0973 111.039C64.0223 113.008 48.9472 113.008 33.8721 111.039C32.2684 110.81 31.1687 109.62 31.352 108.383C33.5514 94.2802 33.5514 80.1771 31.352 66.1198C31.1687 64.8835 32.2684 63.6472 33.8721 63.464C48.9472 61.4951 64.0223 61.4951 79.0973 63.464C80.7011 63.693 81.8008 64.8835 81.6175 66.1198C79.3722 80.1771 79.3722 94.2802 81.6175 108.383Z"
        fill="#F7A600"
      />
      <path
        d="M107.595 8.24219L103.746 9.24955C107.504 23.5816 104.846 37.4558 95.8194 50.4599C88.9921 60.3046 80.9276 65.9367 80.8359 65.9825L83.0812 69.2793C83.4477 69.0504 91.7871 63.2351 99.0268 52.841C108.649 38.9668 111.628 23.5358 107.595 8.24219Z"
        fill="#83BB26"
      />
      <path
        d="M90.0024 69.1876C91.0104 65.616 88.9027 61.9529 85.3745 60.9455C81.8004 59.9381 78.1348 62.0444 77.1267 65.5702C76.1187 69.1418 78.1806 72.8507 81.7546 73.8123C85.2828 74.8196 88.9943 72.7591 90.0024 69.1876Z"
        fill="#1DBADF"
      />
      <path
        d="M106.773 44.2781C107.552 41.5308 105.948 38.6919 103.199 37.9134C100.449 37.135 97.6085 38.7376 96.8296 41.485C96.0506 44.2324 97.6544 47.1171 100.404 47.8497C103.153 48.6281 105.994 47.0255 106.773 44.2781Z"
        fill="#1DBADF"
      />
      <path
        d="M4.31462 126.974L8.16358 125.966C4.40626 111.634 7.06387 97.7601 16.0906 84.7559C22.9179 74.9112 30.9824 69.2791 31.074 69.2334L28.8288 65.9365C28.4622 66.1655 20.1228 71.9807 12.8831 82.3749C3.26074 96.2033 0.282383 111.634 4.31462 126.974Z"
        fill="#83BB26"
      />
      <path
        d="M21.9125 65.9822C20.9044 69.5538 23.0122 73.2169 26.5404 74.2243C30.1144 75.2317 33.7801 73.1253 34.7881 69.5996C35.7962 66.028 33.7342 62.3191 30.1602 61.3575C26.632 60.3501 22.9205 62.4106 21.9125 65.9822Z"
        fill="#1DBADF"
      />
      <path
        d="M5.14209 90.8917C4.36313 93.6391 5.96686 96.478 8.71612 97.2565C11.4654 98.0349 14.3063 96.4322 15.0852 93.6849C15.8642 90.9375 14.2604 88.0528 11.5112 87.3202C8.76194 86.5418 5.92104 88.1444 5.14209 90.8917Z"
        fill="#1DBADF"
      />
      <path
        d="M64.7986 73.2627C61.4078 73.2627 58.4753 75.1858 57.009 77.979C55.5428 75.1858 52.6102 73.2627 49.2195 73.2627C44.3625 73.2627 40.4219 77.2006 40.4219 82.0542C40.4219 93.5474 57.009 102.705 57.009 102.705C57.009 102.705 59.4375 101.377 62.4617 99.0879C64.6153 97.4394 67.0438 95.3331 69.0599 92.8605C71.6717 89.7468 73.642 86.0379 73.642 82.1C73.5962 77.2006 69.6556 73.2627 64.7986 73.2627Z"
        fill="#FF2180"
      />
      <path
        d="M107.274 14.9729C103.792 16.026 100.126 14.0113 99.1179 10.5313C98.3389 7.92131 99.3011 5.17395 101.271 3.57132L103.013 9.38657L107.778 7.9671L106.083 2.15186C108.649 2.42659 110.94 4.16658 111.719 6.82236C112.772 10.2566 110.756 13.9197 107.274 14.9729Z"
        fill="#FF2180"
      />
      <path
        d="M4.68282 120.701C8.16521 119.648 11.8309 121.662 12.8389 125.142C13.6179 127.752 12.6557 130.5 10.6854 132.102L8.94417 126.287L4.17879 127.707L5.91999 133.522C3.35402 133.247 1.06297 131.507 0.284018 128.851C-0.769862 125.371 1.20044 121.708 4.68282 120.701Z"
        fill="#FF2180"
      />
      <path
        d="M54.2617 25.9625C55.224 23.673 56.3237 21.5209 57.3775 19.4146C59.6228 15.0188 61.6847 10.8978 62.4178 5.90674L64.0674 6.13568C63.3343 11.4015 61.1807 15.6599 58.8896 20.1472C57.8358 22.2077 56.736 24.3598 55.8196 26.6035L54.2617 25.9625Z"
        fill="#4C291B"
      />
      <path
        d="M48.031 23.1692C46.6564 21.1087 45.1443 19.1855 43.7238 17.3082C40.6538 13.4619 37.8129 9.79871 36.1634 5.03662L34.6055 5.58609C36.3467 10.5771 39.2792 14.3776 42.395 18.3613C43.8155 20.1929 45.2817 22.0702 46.6564 24.085L48.031 23.1692Z"
        fill="#4C291B"
      />
      <path
        d="M22.7353 42.7673C23.1477 47.0715 24.8889 50.4141 26.63 50.2309C28.3712 50.0478 29.4251 46.4762 29.0127 42.172C28.6003 37.8678 26.8592 34.5252 25.118 34.7084C23.4226 34.8457 22.3229 38.4631 22.7353 42.7673Z"
        fill="#83BB26"
      />
      <path
        d="M80.6532 37.1808C81.0656 41.485 82.8068 44.8277 84.548 44.6445C86.2892 44.4613 87.3431 40.8898 86.9307 36.5856C86.5183 32.2814 84.7771 28.9388 83.0359 29.1219C81.3406 29.3051 80.2409 32.9224 80.6532 37.1808Z"
        fill="#83BB26"
      />
      <path
        d="M83.2199 28.8932L80.1499 29.1679C74.9721 23.0779 64.6166 19.4606 53.0697 20.5595C41.5229 21.7043 32.0379 27.199 28.0973 34.2047L25.0273 34.4795L26.5853 50.4141L29.6553 50.1394C34.833 56.2294 45.1885 59.8467 56.7354 58.7478C68.2823 57.6489 77.7672 52.1541 81.662 45.1484L84.732 44.8736L83.2199 28.8932Z"
        fill="#F7A600"
      />
      <path
        d="M46.3736 41.8008C50.4782 41.8008 53.8057 38.4756 53.8057 34.3738C53.8057 30.272 50.4782 26.9468 46.3736 26.9468C42.2689 26.9468 38.9414 30.272 38.9414 34.3738C38.9414 38.4756 42.2689 41.8008 46.3736 41.8008Z"
        fill="white"
      />
      <path
        d="M62.2725 37.3825C65.165 37.3825 67.5098 35.0393 67.5098 32.1488C67.5098 29.2583 65.165 26.915 62.2725 26.915C59.38 26.915 57.0352 29.2583 57.0352 32.1488C57.0352 35.0393 59.38 37.3825 62.2725 37.3825Z"
        fill="white"
      />
      <path
        d="M47.0127 38.6096C49.6344 38.6096 51.7597 36.4858 51.7597 33.8658C51.7597 31.2459 49.6344 29.1221 47.0127 29.1221C44.3909 29.1221 42.2656 31.2459 42.2656 33.8658C42.2656 36.4858 44.3909 38.6096 47.0127 38.6096Z"
        fill="#83BB26"
      />
      <path
        d="M62.113 35.5323C64.0135 35.5323 65.5542 33.9927 65.5542 32.0936C65.5542 30.1944 64.0135 28.6548 62.113 28.6548C60.2125 28.6548 58.6719 30.1944 58.6719 32.0936C58.6719 33.9927 60.2125 35.5323 62.113 35.5323Z"
        fill="#83BB26"
      />
      <path
        d="M48.8983 38.2342C46.4239 39.2416 43.6288 38.1427 42.6208 35.7158C41.6127 33.289 42.8041 30.4958 45.2326 29.4885C47.6611 28.4811 50.502 29.5801 51.51 32.0069C52.5181 34.4337 51.3726 37.2269 48.8983 38.2342Z"
        fill="#83BB26"
      />
      <path
        d="M51.2383 31.5487L51.6507 31.5029L51.6965 32.2356L51.3299 32.2813L51.2383 31.5487Z"
        fill="url(#paint0_radial_4979_1279)"
      />
      <path
        d="M58.7967 31.2281C58.4302 33.0139 59.6215 34.7997 61.4543 35.166C63.2872 35.5323 65.12 34.3876 65.4866 32.6018C65.8531 30.816 64.6618 29.0303 62.829 28.6639C60.9961 28.2976 59.1633 29.4424 58.7967 31.2281Z"
        fill="#83BB26"
      />
      <path
        d="M47.1175 36.6176C48.7421 36.6176 50.0592 35.3015 50.0592 33.678C50.0592 32.0544 48.7421 30.7383 47.1175 30.7383C45.4928 30.7383 44.1758 32.0544 44.1758 33.678C44.1758 35.3015 45.4928 36.6176 47.1175 36.6176Z"
        fill="#1D1D1B"
      />
      <path
        d="M62.1014 34.0579C63.2858 34.0579 64.2459 33.0984 64.2459 31.9149C64.2459 30.7314 63.2858 29.772 62.1014 29.772C60.9171 29.772 59.957 30.7314 59.957 31.9149C59.957 33.0984 60.9171 34.0579 62.1014 34.0579Z"
        fill="#1D1D1B"
      />
      <path
        d="M46.9303 35.7615C46.8387 36.3568 46.2888 36.7231 45.6932 36.6315C45.0975 36.5399 44.7309 35.9905 44.8226 35.3952C44.9142 34.7999 45.4641 34.4336 46.0597 34.5252C46.6096 34.6626 47.022 35.212 46.9303 35.7615Z"
        fill="white"
      />
      <path
        d="M58.707 31.1826H58.7987L58.8445 31.7321H58.7529L58.707 31.1826Z"
        fill="url(#paint1_radial_4979_1279)"
      />
      <path
        d="M62.51 33.3348C62.6474 33.7469 63.1056 33.9301 63.4722 33.7927C63.8846 33.6553 64.0679 33.1974 63.9304 32.8311C63.793 32.419 63.3348 32.2359 62.9682 32.3732C62.5558 32.5106 62.3725 32.9227 62.51 33.3348Z"
        fill="white"
      />
      <path
        d="M33.1375 12.3632C29.7468 11.539 27.7307 8.10479 28.5554 4.76217C29.3802 1.37376 32.8168 -0.640965 36.1617 0.183242C39.5525 1.00745 41.5686 4.44165 40.7438 7.78427C39.919 11.1269 36.5283 13.1874 33.1375 12.3632Z"
        fill="#83BB26"
      />
      <path
        d="M34.5566 3.84644C34.5566 2.88486 33.7777 2.10645 32.8154 2.10645C31.8532 2.10645 31.0742 2.88486 31.0742 3.84644C31.0742 4.80801 31.8532 5.58643 32.8154 5.58643C33.7777 5.58643 34.5566 4.8538 34.5566 3.84644Z"
        fill="white"
      />
      <path
        d="M65.1224 11.0352C67.7342 10.3942 69.2922 7.73837 68.6507 5.17417C68.0092 2.56418 65.3516 1.00734 62.7856 1.64839C60.1738 2.28944 58.6159 4.94522 59.2574 7.50943C59.8989 10.1194 62.5107 11.6763 65.1224 11.0352Z"
        fill="#83BB26"
      />
      <path
        d="M64.0195 4.48745C64.0195 3.75482 64.6152 3.11377 65.3942 3.11377C66.1273 3.11377 66.7688 3.70903 66.7688 4.48745C66.7688 5.26587 66.1731 5.86113 65.3942 5.86113C64.6152 5.86113 64.0195 5.26587 64.0195 4.48745Z"
        fill="white"
      />
      <path
        d="M47.0664 45.4232C47.7537 49.1779 52.5191 51.5132 57.7427 50.5974C62.9663 49.6816 66.6777 45.8811 66.0363 42.0806"
        stroke="#FF2180"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_4979_1279"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(47.2677 34.8212) rotate(-5.49622) scale(6.81811 21.5898)"
      >
        <stop stopColor="white" />
        <stop offset="0.53" stopColor="#FCFCFC" />
        <stop offset="0.94" stopColor="#F2F2F2" />
        <stop offset="1" stopColor="#F0F0F0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_4979_1279"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(63.505 30.5959) rotate(-5.4962) scale(2.60722 12.0839)"
      >
        <stop stopColor="#51A87C" />
        <stop offset="1" stopColor="#52AA7D" />
      </radialGradient>
      <clipPath id="clip0_4979_1279">
        <rect width="112" height="143" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ecdConnectRobot;
